import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    customers: null,
    inventory: null,
    bank: null,
    invoices: undefined, //la invoices data khi tao ci (tai step1)
    search_invoices: undefined, // la invoices data khi search
    search_banks: undefined, // la banks data khi search
    search_vehicles: null,     //la vehicle data khi search
    commercialinvoices: undefined,
    users: [],
    group_users: [],
    searchTickets: undefined,
    searchFuelTickets: undefined,
    expTickets: undefined,
    impTickets: undefined,
    tcode: undefined,
    serials: undefined,
    form_no: undefined,
    search_loadingtype: null,
    search_saletype: null,
    aircraft: undefined,
    ticketDetail: null,
    //Nguyen add for tanks
    tanks: null,
    permission: undefined,
}
const dataFromBE = createSlice({
    name: 'dataFromBE',
    initialState,
    reducers: {
        setCustomers: (state, action) => {
            if (action.payload === undefined) return
            state.customers = action.payload
        },
        setInventory: (state, action) => {
            if (action.payload === undefined) return
            state.inventory = action.payload
        },
        setBank: (state, action) => {
            if (action.payload === undefined) return
            state.bank = action.payload
        },
        setInvoices: (state,action) => {
            if (action.payload === undefined) return
            state.invoices = action.payload
        },
        setSearchInvoices : (state, action) => {
            if (action.payload === undefined) return
            state.search_invoices = action.payload
        },
        setSearchBanks : (state, action) => {
            if (action.payload === undefined) return
            state.search_banks = action.payload
        },
        setSearchInvoiceForm : (state, action) => {
            if (action.payload === undefined) return
            state.search_invoice_form = action.payload
        },
        setSearchSaleOrder : (state, action) => {
            if (action.payload === undefined) return
            state.search_sale_order = action.payload
        },
        setSearchPrice : (state, action) => {
            if (action.payload === undefined) return
            state.search_price = action.payload
        },
        setSearchCurrency : (state, action) => {
            if (action.payload === undefined) return
            state.search_currency = action.payload
        },
        setSearchPriceUnit : (state, action) => {
            if (action.payload === undefined) return
            state.search_price_unit = action.payload
        },
        setSearchProduct : (state, action) => {
            if (action.payload === undefined) return
            state.search_product = action.payload
        },
        setSearchProductUnit : (state, action) => {
            if (action.payload === undefined) return
            state.search_product_unit = action.payload
        },
        setSearchFlight : (state, action) => {
            if (action.payload === undefined) return
            state.search_flight = action.payload
        },
        setSearchAircraft : (state, action) => {
            if (action.payload === undefined) return
            state.search_aircraft = action.payload
        },
        setCommercialInvoices: (state, action) => {
            if (action.payload === undefined) return
            state.commercialinvoices = action.payload
        },
        setSearchVehicle: (state, action) => {
            if (action.payload === undefined) return
            state.search_vehicles = action.payload
        },
        setGroupVehicles: (state, action) => {
            if (action.payload === undefined) return
            state.group_vehicles = action.payload
        },
        setOrganization: (state, action) => {
            if (action.payload === undefined) return
            state.organization = action.payload
        },
        setUsers: (state, action) => {
            if (action.payload === undefined) return
            state.users = action.payload
        },
        setGroupUsers: (state, action) => {
            if (action.payload === undefined) return
            state.group_users = action.payload
        },
        setExpTickets: (state, action) => {
            if (action.payload === undefined) return
            state.expTickets = action.payload
        },
        setSearchTicket: (state, action) => {
            if (action.payload === undefined) return
            state.searchTickets = action.payload
        },
        setTcode: (state, action) => {
            state.tcode = action.payload
        },
        setSerials: (state, action) => {
            state.serials = action.payload
        },
        setFormNo: (state, action) => {
            state.form_no = action.payload
        },
        setSearchFuelTicket: (state, action) => {
            state.searchFuelTickets = action.payload
        },
        setSearchLoadingType: (state, action) => {
            state.search_loadingtype = action.payload
        },
        setSearchSaleType: (state, action) => {
            state.search_saletype = action.payload
        },
        setAircraft: (state, action) => {
            state.aircraft = action.payload
        },
        setImpTickets: (state, action) => {
            if (action.payload === undefined) return
            state.impTickets = action.payload
        },
        resetDataFromBE: (state) => {
            return {...initialState}
        },
        setTicketDetailRS: (state, action) => {
            state.ticketDetail = action.payload
        },
        // Nguyen add for tanks
        setTanks: (state, action) => {
            state.tanks = action.payload
        },
        setDataFromBEState: (state, action) => {
            if (action.payload.state && action.payload.value) state[action.payload.state] = action.payload.value
            else Object.keys(action.payload).forEach(key => state[key] = action.payload[key])
        }
    }
})

export const {
    setDataFromBEState, setCustomers, setAircraft, setSearchLoadingType, setSearchSaleType, setSearchFuelTicket, setSerials, setFormNo, setSearchTicket, setTcode, setExpTickets, setImpTickets, setGroupUsers, setUsers,
     setGroupVehicles, setOrganization, setSearchVehicle, setSearchBanks, setSearchInvoiceForm, 
     setSearchSaleOrder, setSearchPrice, setSearchCurrency, setSearchPriceUnit, setSearchProduct, setSearchProductUnit, setSearchFlight, setSearchAircraft,
     setSearchInvoices, setTicketDetailRS, setInventory, setBank, setInvoices, setCommercialInvoices, resetDataFromBE,
     setTanks
    } = dataFromBE.actions
export default dataFromBE.reducer